import React from "react";
import { EffectComposer, N8AO, Bloom, Vignette, SMAA, ToneMapping } from "@react-three/postprocessing";
import { ToneMappingMode } from "postprocessing";

/**
 * Post-processing for the rig scene («Høy kvalitet»): screen-space ambient occlusion (N8AO) that darkens the corners
 * under eaves, between modules and at the ground contact, a faint bloom for sun glints on glass and steel, a subtle
 * vignette, SMAA anti-aliasing and ACES filmic tone mapping (the composer disables the renderer's own tone mapping, so
 * it is re-applied here as the final pass; exposure is still read from gl.toneMappingExposure).
 */
export function RigEffects({ enabled = true, isNight = false }) {
  if (!enabled) return null;
  return (
    <EffectComposer multisampling={0} enableNormalPass={false}>
      <N8AO aoRadius={2.2} intensity={isNight ? 1.6 : 2.6} distanceFalloff={1} quality="low" halfRes depthAwareUpsampling />
      <Bloom luminanceThreshold={1.15} luminanceSmoothing={0.2} intensity={isNight ? 0.35 : 0.12} mipmapBlur />
      <Vignette eskil={false} offset={0.22} darkness={isNight ? 0.5 : 0.32} />
      <SMAA />
      <ToneMapping mode={ToneMappingMode.ACES_FILMIC} />
    </EffectComposer>
  );
}
